import { useState } from "react";
import { initialSettings } from "../data/settingsData";
import { UI_SECTIONS, showSection } from "../config/uiVisibility";
import ApiKeysSection from "./settings/ApiKeysSection";
import WebhooksSection from "./settings/WebhooksSection";
import NotificationsSection from "./settings/NotificationsSection";
import SecuritySection from "./settings/SecuritySection";
import TeamMembersSection from "./settings/TeamMembersSection";
import DataRetentionSection from "./settings/DataRetentionSection";

export default function ProfileSettings() {
  const [settings, setSettings] = useState(initialSettings);

  const handleEditWebhook = (webhook) => {
    // TODO: Open edit modal
  };

  const handleAddWebhook = () => {
    // TODO: Open add webhook modal
  };

  const handleNotificationChange = (key, value) => {
    setSettings((prev) => ({
      ...prev,
      notifications: {
        ...prev.notifications,
        [key]: value
      }
    }));
    // TODO: Track changes when save functionality is implemented
  };

  const handleSecurityAction = (action) => {
    // TODO: Handle security actions
  };

  const handleEditTeamMember = (member) => {
    // TODO: Open edit modal
  };

  const handleInviteTeamMember = () => {
    // TODO: Open invite modal
  };

  const handleDataRetentionChange = (key, value) => {
    setSettings((prev) => ({
      ...prev,
      dataRetention: {
        ...prev.dataRetention,
        [key]: value
      }
    }));
    // TODO: Track changes when save functionality is implemented
  };

  // eslint-disable-next-line no-unused-vars -- used by the settings footer, commented out below until save is implemented
  const handleCancel = () => {
    setSettings(initialSettings);
    // TODO: Clear changes tracking when save functionality is implemented
  };

  // eslint-disable-next-line no-unused-vars -- used by the settings footer, commented out below until save is implemented
  const handleSave = () => {
    // TODO: API call to save settings
  };

  // eslint-disable-next-line no-unused-vars -- used by the settings footer, commented out below until save is implemented
  const showFooter =
    showSection(UI_SECTIONS.profileSettings.apiKeys) ||
    showSection(UI_SECTIONS.profileSettings.webhooks) ||
    showSection(UI_SECTIONS.profileSettings.notifications) ||
    showSection(UI_SECTIONS.profileSettings.security) ||
    showSection(UI_SECTIONS.profileSettings.dataRetention);

  return (
    <div className="flex-1 flex flex-col overflow-hidden bg-[#FCFCFC]">
      <div className="flex-1 overflow-auto">
        <div className="px-8 py-7 max-w-[1200px] space-y-6">
          {showSection(UI_SECTIONS.profileSettings.apiKeys) ? (
            <ApiKeysSection />
          ) : null}

          {showSection(UI_SECTIONS.profileSettings.webhooks) ? (
            <WebhooksSection
              webhooks={settings.webhooks}
              onEdit={handleEditWebhook}
              onAdd={handleAddWebhook}
            />
          ) : null}

          {showSection(UI_SECTIONS.profileSettings.notifications) ? (
            <NotificationsSection
              notifications={settings.notifications}
              onChange={handleNotificationChange}
            />
          ) : null}

          {showSection(UI_SECTIONS.profileSettings.security) ? (
            <SecuritySection
              security={settings.security}
              onAction={handleSecurityAction}
            />
          ) : null}

          {showSection(UI_SECTIONS.profileSettings.teamMembers) ? (
            <TeamMembersSection
              onEdit={handleEditTeamMember}
              onInvite={handleInviteTeamMember}
            />
          ) : null}

          {showSection(UI_SECTIONS.profileSettings.dataRetention) ? (
            <DataRetentionSection
              dataRetention={settings.dataRetention}
              onChange={handleDataRetentionChange}
            />
          ) : null}

          {/* {showFooter ? (
            <div className="flex justify-end gap-3 pt-4">
              <button
                type="button"
                onClick={handleCancel}
                className="px-6 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleSave}
                className="px-6 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors"
              >
                Save Changes
              </button>
            </div>
          ) : null} */}
        </div>
      </div>
    </div>
  );
}
